import { render, staticRenderFns } from "./SidreneCijene.vue?vue&type=template&id=480b9c32&scoped=true"
import script from "./SidreneCijene.vue?vue&type=script&lang=js"
export * from "./SidreneCijene.vue?vue&type=script&lang=js"
import style0 from "./SidreneCijene.vue?vue&type=style&index=0&id=480b9c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480b9c32",
  null
  
)

export default component.exports